import { render, staticRenderFns } from "./headerItem.vue?vue&type=template&id=a826f500&scoped=true&"
import script from "./headerItem.vue?vue&type=script&lang=js&"
export * from "./headerItem.vue?vue&type=script&lang=js&"
import style0 from "./headerItem.vue?vue&type=style&index=0&id=a826f500&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a826f500",
  null
  
)

export default component.exports